import Api from '../../shared/Api';

class PlanTemplatesApi {
    static getImages(reference: string): any {
        return new Api().get(`/views/image-gallery/${reference}`);
    }
}

export default PlanTemplatesApi;
